import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b8e1908"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fb-container body" }
const _hoisted_2 = { class: "fb-form" }
const _hoisted_3 = { class: "fb-form-heading-group" }
const _hoisted_4 = {
  key: 0,
  class: "fb-form-heading"
}
const _hoisted_5 = {
  key: 1,
  class: "fb-form-heading"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "Thank you for hauling this trailer!", -1))
const _hoisted_7 = {
  key: 2,
  class: "fb-form-heading"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "You now have possession. Safe travels!", -1))
const _hoisted_9 = { class: "fb-form-image trailer-side success" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-check" }, null, -1))
const _hoisted_11 = {
  version: "1.1",
  class: "fb-svg trailer-side",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 280.5 96.5",
  style: {"enable-background":"new 0 0 280.5 96.5"},
  "xml:space": "preserve"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  class: "fb-path trailer-outline",
  d: "M50.2,84.6c0-6.3,5.1-11.4,11.4-11.4l0,0c6.3,0,11.4,5.1,11.4,11.4l0,0C73.1,90.9,68,96,61.6,96 l0,0C55.3,96,50.2,90.9,50.2,84.6L50.2,84.6z M55.8,84.6c0,3.3,2.6,5.9,5.9,5.9l0,0c3.3,0,5.9-2.6,5.9-5.9l0,0 c0-3.3-2.6-5.9-5.9-5.9l0,0C58.4,78.7,55.8,81.3,55.8,84.6L55.8,84.6z M23.6,84.6c0-6.3,5.1-11.4,11.4-11.4l0,0 c6.3,0,11.4,5.1,11.4,11.4l0,0C46.4,90.9,41.3,96,35,96l0,0C28.7,96,23.6,90.9,23.6,84.6L23.6,84.6z M29.1,84.6 c0,3.3,2.6,5.9,5.9,5.9s5.9-2.6,5.9-5.9l0,0c0-3.3-2.6-5.9-5.9-5.9l0,0C31.8,78.7,29.1,81.3,29.1,84.6z M201.5,91.2V74.1h-99.8 l-21.5,6.5c0,0.1,0,0.2,0,0.3V87h-4.6c0.1-0.8,0.2-1.6,0.2-2.4c0-7.8-6.3-14.2-14.2-14.2c-6,0-11.3,3.8-13.3,9.4 c-2-5.6-7.3-9.4-13.3-9.4c-7.8,0-14.2,6.3-14.2,14.2c0,0.8,0.1,1.6,0.2,2.4h-4.4v-6.1c0-0.3,0-0.7,0.1-1L2.2,74.3v-7.9H280v5.3 h-73.5v19.5L201.5,91.2z M1,56v-6h4c0.6,0,1,0.4,1,1l0,0v4c0,0.6-0.4,1-1,1l0,0H1z M1,38v-6h4c0.6,0,1,0.4,1,1l0,0v4 c0,0.6-0.4,1-1,1l0,0H1z M1,20v-6h4c0.6,0,1,0.4,1,1l0,0v4c0,0.6-0.4,1-1,1l0,0H1z"
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "fb-path trailer-box",
    d: "M278.5,67.5H1.5V6.8c0-2.9,2.4-5.3,5.3-5.3h266.5c2.9,0,5.3,2.4,5.3,5.3L278.5,67.5L278.5,67.5z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "fb-path trailer-outline",
    d: "M6.8,3C4.7,3,3,4.7,3,6.8V66h274V6.8c0-2.1-1.7-3.8-3.8-3.8L6.8,3 M6.8,0h266.5c3.7,0,6.8,3,6.8,6.8V69H0V6.8 C0,3,3,0,6.8,0z"
  })
], -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "fb-form-sub-heading" }
const _hoisted_16 = {
  key: 0,
  class: "call-service-button"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  type: "button",
  class: "btn btn-primary fb-form-button"
}
const _hoisted_19 = {
  key: 1,
  class: "new-search-buttons px-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FbxButton = _resolveComponent("FbxButton")!
  const _component_ReturnOptions = _resolveComponent("ReturnOptions")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isDetach && !_ctx.isFromDetachModal)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_4, " You are now detached from this trailer. Thank you! "))
            : (_ctx.isDetach && _ctx.isFromDetachModal)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_5, [
                  _createTextVNode(" You are now detached. "),
                  _hoisted_6
                ]))
              : (_openBlock(), _createElementBlock("h1", _hoisted_7, [
                  _createTextVNode(" Thank you for moving this trailer! "),
                  _hoisted_8
                ]))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_14))
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", null, "Trailer #" + _toDisplayString(_ctx.trailerNumber), 1)
        ]),
        (_ctx.hasBodyDamage === 'true')
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("a", {
                class: "service-link",
                href: `tel:${_ctx.assistanceNumber}`
              }, [
                _createElementVNode("button", _hoisted_18, _toDisplayString(_ctx.assistanceButtonText), 1)
              ], 8, _hoisted_17)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_FbxButton, {
                "button-text": "Attach Empty Trailer",
                theme: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'EnterTrailer' })))
              }),
              _createVNode(_component_FbxButton, {
                "button-text": "New Trailer Search",
                theme: "return",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'DriverLanding' })))
              })
            ])),
        _createVNode(_component_ReturnOptions)
      ])
    ])
  ]))
}